<div class="d-flex flex-column w-100">
  <div class="header d-flex flex-row px-3 pt-1 w-100">
    <div class="p-2 flex-fill overflow-hidden">
      <h5>{{ 'MassGenerateKITextTitle' | translate }}</h5>
      <span innerHTML="{{ 'MassGenertateKiTextDescription' | translate }}"></span>
    </div>
  </div>
  <dx-toolbar>
    <dxi-item
      location="before"
      widget="dxButton"
      locateInMenu="auto"
      [options]="{ type: 'default', icon: 'revert', text: 'Zurück zur Katalogansicht' | translate, onClick: back }"
    ></dxi-item>
  </dx-toolbar>
  <div class="dx-fieldset">
    <div class="p-2 flex-fill">
      <description-wizard [(prompt)]="prompt"/>
    </div>

    <div class="p-2 flex-fill" *ngIf="prompt">
      <np-description-wizard-field-chooser [(field)]="field"/>
    </div>

    <div class="p-2 flex-fill">
      <div class="dx-field">
        <div class="dx-field-value">
          <dx-button
            text="{{ 'Erstelle KI Texte' | translate }}"
            [disabled]="!(prompt && !!field)"
            (onClick)="createJob()"
          ></dx-button>
        </div>
      </div>
    </div>
  </div>
</div>
